import { gql } from "apollo-boost";

export const CREATE_MANY_ORDER_WITH_ORDER_GROUP = gql`
mutation CreateManyOrderWithOrderGroup($data: ManyOrderWithOrderGroupInput) {
    createManyOrderWithOrderGroup(data: $data) {
      id 
    }
  }
`;
export const CREATE_MANY_ORDER_WITH_ORDER_GROUP_V2 = gql`
mutation CreateManyOrderWithOrderGroupV2($data: ManyOrderWithOrderGroupInput) {
    createManyOrderWithOrderGroupV2(data: $data) {
      id 
    }
  }
`;

export const CREATE_MANY_PENDING_ORDER_WITH_ORDER_GROUP = gql`
mutation CreatePreOrderGroupWithPaymentGateway($data: ManyOrderWithOrderGroupInput) {
  createPreOrderGroupWithPaymentGateway(data: $data) {
      id
      totalPrice
      sumPriceBaht
      sumPriceUsd
      change
      currency
      amount
      receivedMoney
      sumPrice
      payment
      isPaymented
      status
      code
  }
}
`

export const CREATE_MANY_ORDER_WITH_ORDER_GROUP_NOT_YET_PAID = gql`
mutation CreateManyOrderWithOrderGroupNotYetPaid($data: ManyOrderWithOrderGroupInput) {
  createManyOrderWithOrderGroupNotYetPaid(data: $data) {
    id 
  }
}

`

export const CREATE_MANY_ORDER_WITH_ORDER_GROUP_INDEBTED = gql`
mutation Mutation($data: ManyOrderWithOrderGroupInput) {
  createManyOrderWithOrderGroupIndebTed(data: $data) {
    id 
  }
}
`
export const CREATE_MANY_ORDER_WITH_ORDER_GROUP_INDEBTED_V2 = gql`
  mutation Mutation($data: ManyOrderWithOrderGroupInput) {
    createManyOrderWithOrderGroupIndebTedV2(data: $data) {
      id 
    }
  }
`


export const UPDATE_MANY_PENDING_ORDER_GROUP = gql`
mutation UpdatePreOrderGroupWithPaymentGateway($where: OrderWhereInputOne!) {
  updatePreOrderGroupWithPaymentGateway(where: $where) {
    amount
    currency
    paymentDate
    receivedMoney
    shop {
      name
      id
    }
  }
}`

